<div class="landing-page text-white">
    <!-- Navbar -->
    <nav class="navbar">
      <div class="logo">
        <a class="border-0 d-flex align-items-center me-3" id="navbar_logo">
          <img :src="$clientLogo" alt="Logo" class="logo-img mt-2" width="130px">
        </a>
      </div>

      <ul class="nav-links">
        <li>
          <button class="contact-btn">Contact us</button>
        </li>
      </ul>
    </nav>

    <!-- Hero Section -->
    <section class="hero">
      <div class="overlay"></div>
      <div class="hero-content">
        <h1>Guardians of What Matters Most</h1>
        <p>
          We hold and protect assets for families and individuals who value
          discretion, legacy, and long-term trust.
        </p>

        <button class="btn btn-primary-dark btn-sm text-xs  text-dark" @click="access_portal">
          Access Portal
        </button>
      </div>
    </section>
  </div>